import script from "./MobileNav.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileNav.vue?vue&type=script&lang=ts&setup=true"

import "./MobileNav.vue?vue&type=style&index=0&id=58d4485c&scoped=true&lang=css"

import exportComponent from "E:\\Marianne\\workspace\\notion-cooks\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58d4485c"]])

export default __exports__